export enum MessageType {
  ServerError,
  AwaitingResponse,
  NotFound,
}
